import { getDataThrowToMicroapp } from '@/pages/activity-manage/merchants/venue-detail/constants';

const tbInMyCreate = getDataThrowToMicroapp({ baseLink: '/activity-manage/myCreate' });

export { tbInMyCreate };
